import React, { Component } from "react";
// import PropTypes from "prop-types";
import { connect } from "react-redux";
import withAuth from "../../../components/withAuth";
import { Row, Header, Col, Input, HeaderPage, P } from "../../../ui";

// STATE AND STORE
// LIBS
import { sumFormat } from "../../../ui/src/lib/helpers/strings";

class SettingsMarker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      form: {
        sumGive: {
          value: "",
          isNumber: true
        },
        percent: {
          value: "",
          isNumber: true
        },
        days: {
          value: "",
          isNumber: true
        }
      }
    };
  }

  handleInput = e => {
    let value = e.target.value;
    let name = e.target.name;
    const { form } = this.state;

    if (name && form[name]) {
      if (form[name].isNumber) {
        value = String(value) || "";
      }

      this.setState(prevState => {
        return {
          form: {
            ...prevState.form,
            [name]: {
              ...prevState.form[name],
              value
            }
          }
        };
      });
    }
  };

  isNeedCalc = () => {
    return (
      String(this.state.form.sumGive.value).length &&
      parseInt(String(this.state.form.sumGive.value)) > 0 &&
      String(this.state.form.percent.value).length &&
      parseFloat(String(this.state.form.percent.value)) > 0 &&
      String(this.state.form.days.value).length &&
      parseInt(String(this.state.form.days.value)) > 0
    );
  };

  calcSumPercentOnDay = () => {
    return (
      parseInt(this.state.form.sumGive.value, 10) *
      (parseFloat(this.state.form.percent.value) / 100)
    );
  };

  calcSumPercentAll = () => {
    return this.calcSumPercentOnDay() * parseInt(this.state.form.days.value);
  };

  calcSumReturn = () => {
    return (
      parseInt(this.state.form.sumGive.value, 10) + this.calcSumPercentAll() * 1
    );
  };

  calcAPR = () => {
    return Math.pow(
      1 +
        (parseFloat(this.state.form.percent.value) *
          parseInt(this.state.form.days.value, 10)) /
          100,
      365 / parseInt(this.state.form.days.value, 10)
    );
  };

  calcAERR = () => {
    return (
      ((parseInt(this.state.form.sumGive.value, 10) * (this.calcAPR() * 1) -
        parseInt(this.state.form.sumGive.value, 10)) /
        parseInt(this.state.form.sumGive.value, 10)) *
      100
    );
  };

  render() {
    return (
      <div>
        <Row>
          <Col xs={12} sm={6} md={6} lg={6}>
            <HeaderPage
              title="ГЭСВ"
              back={this.props.history.goBack}
            ></HeaderPage>

            <Row>
              <Col>
                <Input
                  label="Сумма выдачи:"
                  name="sumGive"
                  type="integer"
                  value={this.state.form.sumGive.value}
                  handleChange={this.handleInput}
                />
                <Input
                  label="Процент:"
                  name="percent"
                  type="number"
                  value={this.state.form.percent.value}
                  handleChange={this.handleInput}
                />
                <Input
                  label="Кол-во дней:"
                  name="days"
                  type="number"
                  value={this.state.form.days.value}
                  handleChange={this.handleInput}
                />
              </Col>
              <Col>
                <Header size={6}>Сумма процента за день</Header>
                <P>
                  {this.isNeedCalc()
                    ? sumFormat(this.calcSumPercentOnDay())
                    : "-"}
                </P>
                <Header size={6}>Сумма переплаты</Header>
                <P>
                  {this.isNeedCalc()
                    ? sumFormat(this.calcSumPercentAll())
                    : "-"}
                </P>
                <Header size={6}>Сумма к возврату</Header>
                <P>
                  {this.isNeedCalc() ? sumFormat(this.calcSumReturn()) : "-"}
                </P>
                <Header size={6}>APR</Header>
                <P>
                  {this.isNeedCalc()
                    ? sumFormat(parseInt(this.calcAPR() * 100) / 100)
                    : "-"}
                </P>
                <Header size={6}>ГЭСВ</Header>
                <Header size={4}>
                  {this.isNeedCalc()
                    ? sumFormat(parseInt(this.calcAERR() * 100) / 100)
                    : "-"}
                </Header>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  myUser: state.user
});

export default withAuth(connect(mapStateToProps)(SettingsMarker));
